// specializationService.js
import { supabase } from '../lib/supabase';

class SpecializationService {

  async getAllSpecializations() {
    try {
      const { data, error } = await supabase
        .from('specializations')
        .select('id, description')
        .order('description', { ascending: true });

      if (error) throw error;

      return { data, error: null };
    } catch (error) {
      console.error('Erro ao buscar todas as especializações:', error);
      return { data: null, error };
    }
  }

}

export const specializationService = new SpecializationService();
